import React from 'react';
import { useField, FieldHookConfig } from 'formik';
import { Text, Textarea } from '@tonic-ui/react';

import { FieldTextLabel, InlineError } from './index';

type TextareaFieldProps = FieldHookConfig<string | boolean> & {
  placeholder?: string;
  id?: string;
  label?: string;
  onChangeTextArea?: (value: string) => void;
  isRequired?: boolean;
};

const TextareaField = ({
  placeholder = '',
  label = '',
  id = '',
  onChangeTextArea,
  isRequired = false,
  ...rest
}: TextareaFieldProps): JSX.Element => {
  const [field, meta, helpers] = useField(rest);
  const { setValue } = helpers;
  const isInvalid = meta.error && meta.touched ? meta.error : '';
  const invalidTextareaStyle = { error: isInvalid.length > 1 };
  const textAreaId = id || field?.name;

  return (
    <>
      {label !== '' && <FieldTextLabel name={label} htmlFor={textAreaId} isRequired={isRequired} />}
      <Textarea
        {...field}
        id={textAreaId}
        data-id={textAreaId}
        placeholder={placeholder}
        fontWeight={300}
        {...rest}
        {...invalidTextareaStyle}
        onChange={(e) => {
          setValue(e.target.value, true);
          if (onChangeTextArea) onChangeTextArea(e.target.value);
        }}
      />
      {isInvalid && (
        <Text size="xs" mt="1x" data-id="text-area-validation-error">
          <InlineError errorName={isInvalid} />
        </Text>
      )}
    </>
  );
};

TextareaField.displayName = 'Textarea';

export default TextareaField;
